<template>
  <div>
    <PageHeader :schema="$schemas.balance" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.balance" :service="$api.balances" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateBalance',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
